import { DefaultState } from '@portal/portal-core';
import * as Types from '../types';

interface SharedComputerResult {
  open?: boolean;
  success?: boolean;
  result?: unknown;
  error?: unknown;
  errorDetail?: unknown;
}

export interface SharedComputersState {
  userAdminAddSharedComputer: SharedComputerResult;
  userAdminModifySharedComputer: SharedComputerResult;
  productAccessInviteUsers?: Record<string, unknown>;
}

export const initialState: SharedComputersState = {
  userAdminAddSharedComputer: {},
  userAdminModifySharedComputer: {},
};

export function SharedComputers(
  state: SharedComputersState = initialState,
  action: { type: string; payload: SharedComputerResult },
): SharedComputersState {
  const { payload } = action;
  switch (action.type) {
    case Types.CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT:
      return {
        ...state,
        userAdminAddSharedComputer: {
          open: payload.open,
          success: payload.success,
          result: payload.result,
          error: payload.error,
          errorDetail: payload.errorDetail,
        },
      };
    case Types.CLIENT_USER_ADMIN_ADD_SHARED_COMPUTER_RESULT_CLEAR:
      return { ...state, productAccessInviteUsers: {} };
    case Types.CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT:
      return {
        ...state,
        userAdminModifySharedComputer: {
          open: payload.open,
          success: payload.success,
          result: payload.result,
          error: payload.error,
          errorDetail: payload.errorDetail,
        },
      };
    case Types.CLIENT_USER_ADMIN_MODIFY_SHARED_COMPUTER_RESULT_CLEAR:
      return { ...state, userAdminModifySharedComputer: {} };
    case DefaultState.DEFAULT_STATE:
      return initialState;
    default:
      return state;
  }
}
